import { render, staticRenderFns } from "./laptop.vue?vue&type=template&id=3e4d0ef0&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d0ef0",
  null
  
)

export default component.exports